import React, { useState } from 'react';

import { NumberedPagination } from '../common/pagination/NumberedPagination';
import { OrdersListItemLoading } from './OrdersListItemLoading';
import { ListContainer } from '../common/ui/ListContainer';
import { OrdersListHeader } from './OrdersListHeader';
import { Component } from '../common/ui/Component';
import { EmptyCard } from '../common/ui/EmptyCard';
import { OrdersListItem } from './OrdersListItem';

export const OrdersList = ({ isLoading, hasData, data, handlers, onReset }) => {
    const [showChildRowOrderId, setShowChildRowOrderId] = useState(null);
    const { onRefresh, ...paginationHandlers } = handlers;

    const handleShowChildRow = (order) => {
        setShowChildRowOrderId(showChildRowOrderId !== order.id ? order.id : null);
    };

    if (isLoading) {
        return (
            <ListContainer>
                <OrdersListHeader />
                <Component element={OrdersListItemLoading} size={5} />
            </ListContainer>
        );
    }

    if (!hasData) {
        return (
            <ListContainer>
                <EmptyCard icon="file-invoice" text="No results found">
                    <button type="button" className="btn btn-outline-primary" onClick={onReset}>
                        Clear filter
                    </button>
                </EmptyCard>
            </ListContainer>
        );
    }

    return (
        <ListContainer>
            <OrdersListHeader />
            {data.records.map((order) => (
                <OrdersListItem
                    row={order}
                    key={order.id}
                    onRefresh={onRefresh}
                    onShowChildRow={handleShowChildRow}
                    showChildRow={order.id === showChildRowOrderId}
                />
            ))}
            <NumberedPagination className="my-3" data={data} {...paginationHandlers} />
        </ListContainer>
    );
};
